/**
 * Validates a post-login return target.
 *
 * Shared by the API (which stores it on the magic-link row and re-validates at
 * consumption) and the SPA (which reads it out of router state). It lived in
 * both apps as byte-identical copies; a security check that exists twice can
 * be tightened once, so it lives here instead.
 *
 * Accepts a SAME-ORIGIN PATH only. An absolute URL is rejected even when it
 * points at our own host, because the safe set is "path", not "URL we like".
 */
const MAX_RETURN_TO_LENGTH = 512;

export function validateReturnTo(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  if (value.length === 0 || value.length > MAX_RETURN_TO_LENGTH) return null;
  // '//' and '/\' are protocol-relative: the browser reads them as another origin.
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null;
  if (value.includes('://')) return null;
  if (hasControlCharacter(value)) return null;
  return value;
}

function hasControlCharacter(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code <= 31 || code === 127) return true;
  }
  return false;
}
